<template>
  <article class="service-card">
    <div class="service-number">{{ number }}</div>
    <div class="service-icon" v-html="icon"></div>
    <h3>{{ title }}</h3>
    <p>{{ description }}</p>
    <ul>
      <li v-for="item in items" :key="item">{{ item }}</li>
    </ul>
    <router-link :to="link" class="text-link">Explore solution <span>→</span></router-link>
  </article>
</template>

<script>
export default {
  name: 'ServiceCard',
  props: {
    number: String,
    title: String,
    description: String,
    items: Array,
    icon: String,
    link: { type: String, default: '/services' }
  }
}
</script>